import "./SecretMap.css";

/**
 * Feature items data — each drives one card.
 * Add or remove entries here to modify the grid.
 */
const FEATURES = [
  {
    id: "watch-magic",
    icon: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/126.png",
    title: "Spark Curiosity:",
    text: "Jaw dropping stories of legendary super heroes of India to empower young minds and generate curiosity for learning, innovation, and leadership.",
  },
  {
    id: "beat-games",
    icon: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/128.png",
    title: "Decode the Quizzes:",
    text: "Curiosity meets adventure when kids solve the quizzes and answer questions based on the series.",
  },
  {
    id: "collect-loot",
    icon: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/127.png",
    title: "Collect the Loot:",
    text: "Win shiny virtual trophies and cool certificates. Show them off on your profile or use them to make your parents super proud!",
  },
  {
    id: "decode-mystery",
    icon: "https://d2lvj32mp5x83n.cloudfront.net/static/homev2/129.png",
    title: "Decode the Mystery:",
    text: "Dive into stories so cool they couldn't fit in any textbook. Your quest begins now. Are you ready?",
  },
];

export const SecretMap = () => {
  return (
    <section className="secretMap" id="secret-map">
      <div className="secretMap__container">
        {/* Header */}
        <span className="secretMap__badge">KNOW MORE WITH YUVA QUEST</span>
        <h2 className="secretMap__title">
          <img
            className="howitwrkicn"
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 94.png"
            alt=""
          />
          Your Secret Map to the Past
          <img
            className="howitwrkrgticn"
            src="https://d2lvj32mp5x83n.cloudfront.net/static/homev3/image 95.png"
            alt=""
          />
        </h2>

        {/* Cards Grid */}
        <div className="secretMap__grid">
          {FEATURES.map((item) => (
            <FeatureCard key={item.id} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

/** Single feature card with icon + inline title & text */
const FeatureCard = ({ id, icon, title, text }) => (
  <div className="secretMap__card" id={`secret-map-${id}`}>
    <div>
      <img src={icon} alt={title} className="secretMap__icon" />
    </div>
    <div className="secretMap__cardContent">
      <span className="secretMap__cardTitle">{title} </span>
      <span className="secretMap__cardText">{text}</span>
    </div>
  </div>
);
